
Greenmile.TrackEquipment = Greenmile.TrackEquipment || {};

Greenmile.TrackEquipment.Grid = function () {

 

    this.showGrid = function (entity) {

        var options = {
            entity: entity,
            columnCheckBox: {
                show: false
            },
            columnEdit: {
                show: false
            }
        };

        var container = "#" + entity + " #TrackEquipmentWrapper #grid";
        var columns = new Greenmile.TrackEquipment.Utils.getColumns();

        var dataView = new Monet.Grid.DataProvider(columns, null, entity);
        var grid = new Monet.Grid.GenericGrid(container, dataView, columns, options);

        grid.onClick.subscribe(function (e, args) {

            Monet.Session.TrackEquipmentMaps.events = [];
            const selectedEquipment = args.grid.getDataItem(args.row);
            Greenmile.TrackEquipment.Grid.selectedEquipment = selectedEquipment;
            App.Views.TrackEquipmentMaps.clearEquipmentRoute({ removeEvents: true });
            Greenmile.Map.Utility.removeLayerByKind(Monet.Session.TrackEquipmentMaps.map, ['equipOffInStop']);
            App.Objects.TrackEquipmentMaps.requestEventsAndCoordsByDataRange(selectedEquipment.idOfObject);


        });

        App.Forms[entity].table = grid;
        App.Forms[entity].dataProvider = dataView;
    };

    this.clear = function () {
        App.Views.TrackEquipmentMaps.equipment = {};
        Monet.Session.TrackEquipmentMaps.events = [];
        if (App.Forms.TrackEquipmentMaps.table !== null) {
            App.Forms.TrackEquipmentMaps.table.invalidateAllRows();
        }
    };
};
